// Imports
import ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ from "../../../../node_modules/html-loader/dist/runtime/getUrl.js";
var ___HTML_LOADER_IMPORT_0___ = new URL("../../../../public/css/svg.svg", import.meta.url);
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___, { hash: "#add" });
var code = "\r\n\r\n<div class=\"fab fab-app\"\r\n\tdata-detail='{\"click\": [  {\"dest\":\"ripple\" }, {\"dest\":\"fab\", \"act\":\"add\" } ] }'\r\n >\r\n  <svg><use xlink:href='" + ___HTML_LOADER_REPLACEMENT_0___ + "'></use></svg>\r\n</div>\r\n";
// Exports
export default code;